const baseSettings         = require('../../../config/media-query-settings');
const DDMatchMediaSettings = require('../../js/lib/dd-match-media/dd-match-media-settings');



module.exports = DDMatchMediaSettings(baseSettings);



// WEBPACK FOOTER //
// ./src/sass/js-variables/media-query-settings.js